import React from "react";
import { FiPlus } from "react-icons/fi";
import TemplateCard from "./TemplateCard";
import TemplateEmptyState from "./TemplateEmptyState";
import ComingSoonBanner from "../common/ComingSoonBanner";
import {
  builtInTemplates,
  categoryLabels,
  BuiltInTemplate,
} from "../../data/builtInTemplates";

const PlusIcon = FiPlus as React.FC<React.SVGProps<SVGSVGElement>>;

interface CustomTemplate {
  id: string;
  name: string;
  description: string;
  subject: string;
}

interface TemplatesTabProps {
  customTemplates: CustomTemplate[];
  isLoading: boolean;
  onUseTemplate: (templateId: string, isBuiltIn: boolean) => void;
  onCreateTemplate: () => void;
  onEditTemplate?: (templateId: string) => void;
  onDeleteTemplate?: (templateId: string) => void;
}

/**
 * TemplatesTab - Displays built-in and custom email templates
 */
const TemplatesTab: React.FC<TemplatesTabProps> = ({
  customTemplates,
  isLoading,
  onUseTemplate,
  onCreateTemplate,
  onEditTemplate,
  onDeleteTemplate,
}) => {
  // Group built-in templates by category
  const templatesByCategory = builtInTemplates.reduce((acc, template) => {
    if (!acc[template.category]) {
      acc[template.category] = [];
    }
    acc[template.category].push(template);
    return acc;
  }, {} as Record<string, BuiltInTemplate[]>);

  const categories = ["founders", "engineering", "product"];

  return (
    <div className="su-emails-tab-content">
      {/* Built-in Templates Section */}
      <div className="su-section">
        <div className="su-section-header-flat">
          <div>
            <h2 className="su-text-section-heading">Built-in Templates</h2>
            <p className="su-text-subtitle mt-1">
              Pre-made templates for common update types
            </p>
          </div>
        </div>

        {categories.map((category) => (
          <div key={category} className="su-template-category">
            <h3 className="su-template-category-label">
              {categoryLabels[category]}
            </h3>
            <div className="su-template-grid">
              {templatesByCategory[category]?.map((template) => (
                <TemplateCard
                  key={template.id}
                  name={template.name}
                  description={template.description}
                  subject={template.subject}
                  isBuiltIn
                  onUse={() => onUseTemplate(template.id, true)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* My Templates Section - Coming Soon */}
      <div className="su-section">
        <div className="su-section-header-flat">
          <div>
            <h2 className="su-text-section-heading">My Templates</h2>
            <p className="su-text-subtitle mt-1">Your saved custom templates</p>
          </div>
        </div>

        <div className="mt-4">
          <ComingSoonBanner
            title="Custom Templates Coming Soon"
            subtitle="Create and save your own reusable email templates. This feature is currently in development."
          />
        </div>
      </div>
    </div>
  );
};

export default TemplatesTab;

